import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { compose } from "redux";
import pluralize from "pluralize";
import { formName } from "./constants";
import { typeField } from "./helperComponents/PropertiesDialog/typeField";
import {
  DataTable,
  DialogFooter,
  withSelectTableRecords,
  withSelectedEntities
} from "@teselagen/ui";
import { Button } from "@blueprintjs/core";
import { startCase } from "lodash-es";
import { tidyUpAnnotation } from "@teselagen/sequence-utils";
const similarityField = {
  path: "similarity",
  type: "number",
  displayName: "Similarity %",
  render: (val) => val !== void 0 ? `${val}%` : ""
};
const lengthField = {
  path: "length",
  type: "number",
  displayName: "Length"
};
const startField = {
  path: "start",
  displayName: "Start",
  render: (val) => val + 1
};
const endField = {
  path: "end",
  displayName: "End",
  render: (val) => val + 1
};
const fileSourceField = {
  path: "fileSource",
  displayName: "File Source"
};
const schemaFeatures = [
  "name",
  typeField,
  startField,
  endField,
  lengthField,
  "strand",
  similarityField,
  fileSourceField
];
const schemaOther = [
  "name",
  startField,
  endField,
  lengthField,
  "strand",
  similarityField,
  fileSourceField
];
export default compose(
  withSelectedEntities(formName),
  withSelectTableRecords(formName)
)(function CreateAnnotationsPage(props) {
  const {
    newAnnotations,
    annotationType,
    annotationVisibilityShow,
    beforeAnnotationCreate,
    handleSubmit,
    sequenceData,
    hideModal,
    setNewAnns
  } = props;
  const ents = props[`${formName}SelectedEntities`] || [];
  const entities = useMemo(() => {
    const seqLen = sequenceData.size || (sequenceData.sequence || "").length || 0;
    return newAnnotations.map((e) => {
      return {
        ...e,
        length: e.end >= e.start ? e.end - e.start + 1 : seqLen ? e.end + 1 + seqLen - e.start : ""
      };
    });
  }, [newAnnotations, sequenceData]);
  return /* @__PURE__ */ jsxs("div", { className: "bp3-dialog-body", children: [
    /* @__PURE__ */ jsxs("div", { children: [
      "The following ",
      annotationType,
      newAnnotations.length > 1 ? "s" : "",
      " will be added:",
      /* @__PURE__ */ jsx(
        DataTable,
        {
          isInfinite: true,
          formName,
          entities,
          withCheckboxes: true,
          schema: annotationType === "feature" ? schemaFeatures : schemaOther
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      DialogFooter,
      {
        containerClassname: "create-annotations-footer",
        hideModal,
        additionalButtons: /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Button, { text: "Back", onClick: () => setNewAnns(false) }),
          /* @__PURE__ */ jsx(
            Button,
            {
              text: "Preview",
              onClick: handleSubmit(async () => {
                const annotationTypePlural = pluralize(annotationType);
                const previewAnnotations = [];
                ents.forEach((newAnnotation) => {
                  beforeAnnotationCreate && beforeAnnotationCreate({
                    annotationTypePlural,
                    annotation: newAnnotation,
                    props
                  });
                  const previewAnnotation = {
                    ...newAnnotation,
                    isPreview: true,
                    name: `${newAnnotation.name} (${Math.round(
                      newAnnotation.similarity || 100
                    )}% match)`,
                    opacity: 0.7
                  };
                  previewAnnotations.push(
                    tidyUpAnnotation(previewAnnotation, {
                      sequenceData,
                      annotationType: annotationTypePlural
                    })
                  );
                });
                if (previewAnnotations.length > 0) {
                  props[`upsert${startCase(annotationType)}`](previewAnnotations);
                  annotationVisibilityShow(annotationTypePlural);
                }
                hideModal();
              })
            }
          )
        ] }),
        onClick: handleSubmit(async () => {
          const annotationTypePlural = pluralize(annotationType);
          const annotationsToCreate = [];
          ents.forEach((newAnnotation) => {
            beforeAnnotationCreate && beforeAnnotationCreate({
              annotationTypePlural,
              annotation: newAnnotation,
              props
            });
            annotationsToCreate.push(
              tidyUpAnnotation(newAnnotation, {
                sequenceData,
                annotationType: annotationTypePlural
              })
            );
          });
          if (annotationsToCreate.length > 0) {
            props[`upsert${startCase(annotationType)}`](annotationsToCreate);
            annotationVisibilityShow(annotationTypePlural);
          }
          hideModal();
        }),
        text: "Add"
      }
    )
  ] });
});
